import React from "react";
import { merge } from "lodash";
import MaterialTable, { MaterialTableProps } from "material-table";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  table: {
    "& table": {
      wordBreak: "keep-all",
      "& th": {
        lineHeight: 1,
        fontWeight: 400,
      },
      "& td": {
        padding: theme.spacing(1, 2),
      },
    },
  },
}));

interface Props<T extends object> extends MaterialTableProps<T> {
  className?: string;
}

export default <T extends object>({ className, ...props }: Props<T>) => {
  const styles = useStyles();

  return (
    <div className={[className, styles.table].join(" ")}>
      <MaterialTable
        {...merge<MaterialTableProps<T>, MaterialTableProps<T>>(
          {
            title: "",
            data: [],
            columns: [],
            options: {
              exportButton: true,
              paginationType: "stepped",
              pageSize: 25,
              pageSizeOptions: [25, 50, 100],
              emptyRowsWhenPaging: false,
            },
            localization: {
              header: {
                actions: "",
              },
              toolbar: {
                searchTooltip: "検索",
                searchPlaceholder: "検索",
                exportTitle: "エクスポート",
                exportName: "CSVとして保存",
              },
              body: {
                emptyDataSourceMessage: "表示するデータがありません",
              },
              pagination: {
                firstTooltip: "最初へ",
                firstAriaLabel: "最初へ",
                previousTooltip: "前へ",
                previousAriaLabel: "前へ",
                nextTooltip: "次へ",
                nextAriaLabel: "次へ",
                lastTooltip: "最後へ",
                lastAriaLabel: "最後へ",
                labelDisplayedRows: "{from} - {to} / {count}",
                labelRowsSelect: "件",
              },
            },
          },
          props
        )}
      />
    </div>
  );
};
